import React from "react";
import { TableCell, TableRow } from "@mui/material";
import ImagesTableRow from "./ImagesTableRow";
import EntityListTable from "../../helpers/EntityListTable";
import ImageCreateButton from "./Image/ImageCreateButton";

const ImagesTable = ({
  imagesList,
  currentPage,
  onPageButtonClicked,
}) => {
  const displayedImages = imagesList.slice(0, 10);
  const hasNextPage = imagesList.length === 11;

  return (
    <>
      <ImageCreateButton/>
      <EntityListTable
        currentPage={currentPage}
        hasNextPage={hasNextPage}
        onPageButtonClicked={onPageButtonClicked}
        tableHeaderComponent={
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Label</TableCell>
            <TableCell align="right">Credit</TableCell>
            <TableCell align="right">Type</TableCell>
          </TableRow>
        }
      >
        {displayedImages.map(
          (image) => <ImagesTableRow
            key={image.imageEntityId}
            image={image}/>,
        )}
      </EntityListTable>
    </>
  );
};

export default ImagesTable;
